import { gql } from "@apollo/client";

const UPDATE_MY_TTS_PREFERENCES = gql`
  mutation updateMyTtsPreferences($voice: String!, $toneId: String) {
    updateMyTtsPreferences(voice: $voice, toneId: $toneId) {
      voice
      toneId
    }
  }
`;

export default UPDATE_MY_TTS_PREFERENCES;
